export const VTB_MORTGAGE_RATE_FLATS = '6';
export const VTB_MORTGAGE_RATE_APARTS = '16,4';
